export class RefreshProductsRequest {
  planogramId: string = '';
  stateId: string = '';
  fields: string[] = [];

  constructor(planogramId: string, stateId: string, fields: string[]) {
    this.planogramId = planogramId;
    this.stateId = stateId;
    this.fields = fields;
  }
}